import "./Enderecos.css";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import fotoConsultorio from "../../assets/img/fotoConsultorio.png";

function Enderecos() {
  const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", { state: { scrollTo: id } });
  };

  const locais = [
    {
      cidade: "Teresópolis",
      endereco: "R. Prefeito Sebastião Teixeira, 354 - Cobertura nº 05, Várzea",
      horario: "Qua 14h-18h, Sex 13h-18h",
      label: "Teresópolis",
      mapa: "https://www.google.com/maps?q=Av.+Feliciano+Sodré,+266+Teresópolis&output=embed",
      rota: "https://www.google.com/maps/dir/?api=1&destination=Av.+Feliciano+Sodré,+266+Teresópolis",
      link: "https://wa.me/5521983132240?text=Vim%20pelo%20site%20e%20quero%20agendar%20minha%20consulta%20nesta%20unidade%20%de%20%Teresópolis"
    },
    {
      cidade: "Rio de Janeiro",
      endereco: "Livance Botafogo - Rua Visconde de Ouro Preto, 5 - 5º andar",
      horario: "Seg 14h-19h, Ter 08h-13h, Qui 16h-19h",
      label: "Botafogo",
      mapa: "https://www.google.com/maps?q=Livance+Botafogo&output=embed",
      rota: "https://www.google.com/maps/dir/?api=1&destination=Livance+Botafogo",
      link: "https://wa.me/5521983132240?text=Vim%20pelo%20site%20e%20quero%20agendar%20minha%20consulta%20nesta%20unidade%20%do%20%Rio%20de%20Janeiro"
    }
  ];

  return (
    <section className="enderecos-section" id="enderecos">
      <div className="container">

        <h2 className="enderecos-title text-center scroll-reveal-opacity">
          Nossos Endereços
        </h2>

        <div className="row g-4">

          {locais.map((item, index) => (
            <div key={index} className="col-12 col-md-6 scroll-reveal-opacity">

              <div className="endereco-card">

                {/* MAPA */}
                <div className="endereco-map">
                  <iframe
                    src={item.mapa}
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>

                  {/* <span className="badge-local">
                    {item.label}
                  </span> */}
                </div>

                {/* CONTEÚDO */}
                <div className="endereco-content">

                  <h3>{item.cidade}</h3>

                  <p>{item.endereco}</p>

                  <div className="horario">
                    <span className="material-symbols-outlined">
                      schedule
                    </span>
                    <span>{item.horario}</span>
                  </div>

                  {/* BOTÕES */}
                  <div className="endereco-actions">

                    <a
  href={item.rota}
  target="_blank"
  rel="noopener noreferrer"
  className="btn-rota"
  onClick={() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "route_click",
      origem: "secao_enderecos",
      unidade: item.cidade,
      pagina: window.location.pathname,
    });
  }}
>
  Ver rota
</a>

                    <a
  href={item.link}
  target="_blank"
  rel="noopener noreferrer"
  className="btn-agendar-local"
  onClick={() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "whatsapp_click",
      origem: "secao_enderecos",
      tipo: "agendar_unidade",
      unidade: item.cidade,
      pagina: window.location.pathname,
    });
  }}
>
  Agendar aqui
</a>

                  </div>

                </div>

              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
}

export default Enderecos;